<template>
    <div class="row">
        <div class="col-md-6">
            <datepicker v-model="valid_from"
                        :label="t_label_start"
                        :max="valid_to"
                        popup-used-in-modal />
        </div>
        <div class="col-md-6">
            <datepicker v-model="valid_to"
                        :label="t_label_end"
                        :min="valid_from"
                        align-right
                        popup-used-in-modal />
        </div>
    </div>
</template>

<script>

export default {
    components: {
        datepicker: require('../../../common/datepicker.vue').default
    },
    props: ['value'],
    data: function() {
        return {
            t_label_start: Lang.langGet('Not before'),
            t_label_end: Lang.langGet('Not after'),
            valid_from: this.value.valid_from,
            valid_to: this.value.valid_to
        }
    },
    watch: {
        valid_from() {
            this.$emit('input', { valid_from: this.valid_from, valid_to: this.valid_to })
        },
        valid_to() {
            this.$emit('input', { valid_from: this.valid_from, valid_to: this.valid_to })
        }
    }
}
</script>
